import styled from 'styled-components'
import { layout } from 'src/styles/layout'
import { palette } from 'styles/colors'

export const FoundersSectionWrapper = styled.div`
  background-color: ${palette.catskillWhite};
  max-width: 100% !important;
`

export const FoundersContainer = styled.div`
  padding: 5em 0em 2rem;

  & > div {
    &:first-child {
      & > h1 {
        max-width: 620px;
        margin: 0 auto 20px;
      }
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding-top: 3rem;
  }
`;

export const FounderProfilesContainer = styled.div`
  max-width: 1160px;
  margin: 0 auto;
`

export const FounderProfile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FounderProfileImage = styled.div`
  width: 100%;
  max-width: 420px;

  > div {
    margin: 0 auto;
  }
  @media all and (max-width: ${layout.subMd}) {
    margin-bottom: 0.5rem;
  }
`

export const HiringCallToActionWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 40px auto;

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    span {
      text-align: center;

      :first-child {
        order: 1;
      }
    }
  }

  @media screen and (min-width: ${layout.xxs}) {
    a {
      flex-direction: row;
    }
  }
`

